import React, { useEffect, useState, useContext, useRef } from "react";
import {
  ProgramParticipantsContainer,
  PillContainer,
  ParticipantButtonsRow,
  SearchBoxRow,
  SearchBoxContainer,
  SearchIcon,
  MyTeamContainers,
  ButtonText,
  BackButton,
  ParticipantsOuterContainer,
  Export,
  ExportText,
  ExportContainer,
  ExportOption,
  ExportOptions,
  FilterContainer,
} from "./styles";
import ActiveParticipants from "./ActiveParticipants";
import TextInput from "../../../../../common/TextInput";
import Button from "../../../../../common/Button";
import Icon from "../../../../../common/Icon";
import AddParticipants from "../../popups/AddParticipants";
import Invites from "./Invites";
import PendingRequests from "./PendingRequests";
import MyTeams from "../MyTeams";
import ProgramDashboard from "./ProgramDashboard";
import Mentors from "./Mentors";
import { useParams } from "react-router-dom";
import callAPI from "../../../../../api/apiCaller";
import { Context } from "../../../../../Store";
import Applicants from "./Applicants";
import { Participant } from "./Mentors/styles";
import { ExportCSV } from "../../../../../common/utils";
import Pills from "../../../../../common/Pills";
import {
  FilterOption,
  FilterOptions,
  FilterText,
  FilterBy,
  FilterHeadText,
  FilterLabel,
  FilterLabelText,
  FilterClear,
  FilterButtons,
  ResetButton,
  ApplyButton,
  // Select,
  Select2,
  Option,
} from "./Applicants/styles";
import {
  SearchBoxFilterContainer,
  SearchBoxFilterContainer2,
  SearchParticipantsWrapper,
} from "./Applicants/styles";

function ProgramParticipants({ program }) {
  const params = useParams();
  const [currentPage, setCurrentPage] = useState("active");
  const [searchText, setSearchText] = useState("");
  const [isAddParticipantsOpen, setIsAddParticipantsOpen] =
    React.useState(false);
  const [refreshInvites, setRefreshInvites] = useState(false);
  const [specificTeamProgram, setSpecificTeamProgram] = useState(false);
  const [joinAs, setJoinAs] = useState("");
  const [switchToParticipant, setSwitchToParticipants] =
    React.useState("participants");
  const [programType, setProgramType] = useState(null);
  const { dispatch } = useContext(Context);
  const [openExport, setOpenExport] = useState(false);
  // const [exportData, setExportData] = useState([]);
  // const [exportCurrentPageData, setExportCurrentPageData] = useState([]);
  const childRef = useRef();

  const programInformation = () => {
    callAPI(dispatch, "getProgramInformation", {
      id: params.selectedProgram,
    }).then((info) => {
      setProgramType(info.data.programType);
    });
  };

  useEffect(() => {
    programInformation();
  }, []);

  const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

  const mentorMenteeLabels = [
    "Full Name",
    "Role",
    "Status",
    "Track Hours",
    "Mentees",
    "Mentor Name",
  ];
  const mentorMenteeKeys = [
    "fullName",
    "role",
    "status",
    "trackHours",
    "mentees",
    "mentorName",
  ];

  const [mentorMenteeDate, setMentorMenteeData] = useState();
  const [unassignedMenteeDate, setunassignedMenteeData] = useState();

  const exportMentorMenteeHandler = () => {
    const tableData = mentorMenteeDate?.flatMap((data) => {
      const mentorData = {
        fullName:
          capitalize(data?.participant?.firstName) +
          " " +
          capitalize(data?.participant?.lastName),
        role: "Mentor",
        status: data?.status ? data?.status : "-",
        trackHours: data?.totalTrackHours ? data?.totalTrackHours : "-",
        mentees: data?.mentees?.length ? data?.mentees?.length : "0",
        mentorName: "-",
      };

      // return mentorData;

      const menteeData =
        data?.mentees?.map((mentee) => {
          return {
            fullName:
              capitalize(mentee?.participant?.firstName) +
              " " +
              capitalize(mentee?.participant?.lastName),
            role: "Mentee",
            status: data?.status ? data?.status : "-",
            trackHours: data?.totalTrackHours ? data?.totalTrackHours : "-",
            mentees: "-",
            mentorName:
              capitalize(data?.participant?.firstName) +
              " " +
              capitalize(data?.participant?.lastName),
          };
        }) ?? [];

      return [mentorData, ...menteeData];
    });

    ExportCSV({
      labels: mentorMenteeLabels,
      dataKeys: mentorMenteeKeys,
      tableData: tableData,
      fileName: "Assigned_Mentor_Mantees_Data",
    });
  };

  const menteeLabels = ["Full Name", "Role", "Status", "Track Hours"];
  const menteeKeys = ["fullName", "role", "status", "trackHours"];

  const exportUnassignedMenteeHandler = () => {
    const tableData = unassignedMenteeDate?.map((mentee) => {
      return {
        fullName:
          capitalize(mentee?.participant?.firstName) +
          " " +
          capitalize(mentee?.participant?.lastName),
        role: "Mentee",
        status: mentee?.status,
        trackHours: mentee?.trackedHours ? mentee?.trackedHours : "-",
      };
    });

    ExportCSV({
      labels: menteeLabels,
      dataKeys: menteeKeys,
      tableData: tableData,
      fileName: "Unassigned_Mantes_Data",
    });
  };

  /*** Filter Logic ***/
  const [filterOptions, setFilterOptions] = useState(false);
  const [filterLoader, setFilterLoader] = useState(false);
  const [resetLoader, setResetLoader] = useState(false);
  const [status, setStatus] = useState("");
  const [mentorName, setMentorName] = useState("");

  const [storedFilterFunction, setStoredFilterFunction] = useState(null);
  const [storedAllFunction, setStoredAllFunction] = useState(null);

  const statusChangeHandler = (event) => {
    setStatus(event.target.value);
  };

  const mentorNameChangeHandler = (value) => {
    setMentorName(value);
  };

  const resetFilters = () => {
    setStatus("");
    setMentorName("");

    setResetLoader(true);

    if (storedAllFunction) {
      storedAllFunction();
    }
  };

  const filterDataHandler = () => {
    // console.log("Called 111");
    setFilterLoader(true);

    if (storedFilterFunction) {
      // console.log("Called 222");

      storedFilterFunction(mentorName, status);
    }
  };
  /*** Filter Logic ***/

  return (
    <ProgramParticipantsContainer>
      {specificTeamProgram ? (
        <MyTeamContainers>
          <MyTeams specificTeamProgram={true} />
        </MyTeamContainers>
      ) : (
        <>
          {programType === "1_1_NETWORK" || programType === "OPEN_NETWORK" ? (
            <>
              {" "}
              {switchToParticipant === "participants" ? (
                <ProgramDashboard
                  setSwitchToParticipants={setSwitchToParticipants}
                  setJoinAs={setJoinAs}
                  programType={programType}
                />
              ) : switchToParticipant === "mentors" ? (
                <Mentors
                  joinAs={joinAs}
                  setSwitchToParticipants={setSwitchToParticipants}
                />
              ) : switchToParticipant === "active" ? (
                <ParticipantsOuterContainer>
                  <PillContainer>
                    <ParticipantButtonsRow>
                      <BackButton
                        onClick={() => {
                          setSwitchToParticipants("participants");
                        }}
                      >
                        <Icon type="back" color="#302F2F" />
                        <ButtonText>Back</ButtonText>
                      </BackButton>
                      <ExportContainer>
                        <Export onClick={() => setOpenExport(!openExport)}>
                          <Icon type={"export"} />
                          <ExportText>Export</ExportText>
                          <Icon type={"chevron-down"} />
                        </Export>
                        {openExport && (
                          <>
                            <ExportOptions>
                              <ExportOption onClick={exportMentorMenteeHandler}>
                                Export Mentor & Mentees
                              </ExportOption>
                              <ExportOption
                                onClick={exportUnassignedMenteeHandler}
                              >
                                Export Unassigned Mentees
                              </ExportOption>
                            </ExportOptions>
                          </>
                        )}
                      </ExportContainer>
                    </ParticipantButtonsRow>

                    <SearchBoxFilterContainer2>
                      <SearchBoxContainer>
                        <SearchIcon>
                          <Icon type="search" />
                        </SearchIcon>
                        <TextInput
                          placeholder="Search for Participant"
                          value={searchText}
                          setValue={setSearchText}
                          isIcon={true}
                        />
                      </SearchBoxContainer>

                      <FilterContainer
                        onMouseEnter={() => setFilterOptions(true)}
                        onMouseLeave={() => setFilterOptions(false)}
                      >
                        <FilterOption style={{ height: "90%" }}>
                          <Icon type="filter" />
                          <FilterText>Filter</FilterText>
                        </FilterOption>
                        {/* {true && ( */}
                        {filterOptions && (
                          <FilterOptions>
                            <FilterHeadText>Filter By</FilterHeadText>
                            <FilterBy>
                              <FilterLabel>
                                <FilterLabelText>Mentor Name</FilterLabelText>
                                <FilterClear onClick={() => setMentorName("")}>
                                  Clear
                                </FilterClear>
                              </FilterLabel>

                              <TextInput
                                placeholder="Mentor Name"
                                value={mentorName}
                                setValue={mentorNameChangeHandler}
                                isIcon={false}
                              />
                            </FilterBy>
                            <FilterBy>
                              <FilterLabel>
                                <FilterLabelText>Status</FilterLabelText>
                                <FilterClear onClick={() => setStatus("")}>
                                  Clear
                                </FilterClear>
                              </FilterLabel>
                              <Select2
                                id="status"
                                value={status}
                                onChange={statusChangeHandler}
                              >
                                <Option value="" disabled>
                                  Choose Option
                                </Option>
                                <Option value="active">Active</Option>
                                <Option value="deactivated">Deactivated</Option>
                              </Select2>
                            </FilterBy>
                            <FilterButtons>
                              <ResetButton onClick={resetFilters}>
                                {resetLoader ? (
                                  <Icon
                                    type={"loading"}
                                    size="16"
                                    color="#000000"
                                  />
                                ) : (
                                  "Reset All"
                                )}
                              </ResetButton>
                              <ApplyButton onClick={filterDataHandler}>
                                {filterLoader ? (
                                  <Icon
                                    type={"loading"}
                                    size="16"
                                    color="#ffffff"
                                  />
                                ) : (
                                  "Apply Filter"
                                )}
                              </ApplyButton>
                            </FilterButtons>
                          </FilterOptions>
                        )}
                      </FilterContainer>
                    </SearchBoxFilterContainer2>
                  </PillContainer>
                  <ActiveParticipants
                    searchText={searchText}
                    specificTeamProgram={specificTeamProgram}
                    setSpecificTeamProgram={setSpecificTeamProgram}
                    setMentorMenteeData={setMentorMenteeData}
                    setunassignedMenteeData={setunassignedMenteeData}
                    setStoredFilterFunction={setStoredFilterFunction}
                    setStoredAllFunction={setStoredAllFunction}
                    setFilterLoader={setFilterLoader}
                    setResetLoader={setResetLoader}
                  />
                </ParticipantsOuterContainer>
              ) : (
                <Applicants setSwitchToParticipants={setSwitchToParticipants} />
              )}
            </>
          ) : null}

          {programType === "TEAM" ? (
            <ParticipantsOuterContainer>
              <PillContainer>
                {/* <ParticipantButtonsRow> */}
                {/* <ExportContainer>
                    <Export onClick={() => setOpenExport(!openExport)}>
                      <Icon type={"export"} />
                      <ExportText>Export</ExportText>
                      <Icon type={"chevron-down"} />
                    </Export>
                    {openExport && (
                      <>
                      <ExportOptions>
                        <ExportOption onClick={() => handleExport("all")}>Export All</ExportOption>
                        <ExportOption onClick={() => handleExport("current")}>
                        Export Current Page
                        </ExportOption>
                      </ExportOptions>
                      </>
                    )}
                  </ExportContainer> */}

                {/* </ParticipantButtonsRow> */}

                <SearchBoxRow>
                  <SearchBoxContainer>
                    <SearchIcon>
                      <Icon type="search" />
                    </SearchIcon>
                    <TextInput
                      placeholder="Search for Participant"
                      value={searchText}
                      setValue={setSearchText}
                      isIcon={true}
                    />
                  </SearchBoxContainer>
                  {/* <Button
                    text="Filter"
                    borderRadius="5px"
                    backgroundColor="transparent"
                    variant="primary"
                    icon="filterTransparent"
                  /> */}
                  <Pills
                    value={currentPage}
                    setValue={setCurrentPage}
                    options={[
                      {
                        label: "Active",
                        value: "active",
                      },
                      {
                        label: "Invites",
                        value: "invites",
                      },
                      {
                        label: "Applications",
                        value: "requests",
                      },
                    ]}
                  />

                  <Button
                    icon="add"
                    text="Add Participants"
                    onClick={() => {
                      setIsAddParticipantsOpen(true);
                    }}
                  />
                </SearchBoxRow>
              </PillContainer>
              {currentPage === "active" && (
                <ActiveParticipants
                  searchText={searchText}
                  specificTeamProgram={specificTeamProgram}
                  setSpecificTeamProgram={setSpecificTeamProgram}
                  setMentorMenteeData={setMentorMenteeData}
                  setunassignedMenteeData={setunassignedMenteeData}
                  setStoredFilterFunction={setStoredFilterFunction}
                  setStoredAllFunction={setStoredAllFunction}
                  setFilterLoader={setFilterLoader}
                  setResetLoader={setResetLoader}
                />
              )}
              {currentPage === "invites" && (
                <Invites
                  searchText={searchText}
                  refreshInvites={refreshInvites}
                  setRefreshInvites={setRefreshInvites}
                />
              )}
              {currentPage === "requests" && (
                <PendingRequests program={program} searchText={searchText} />
              )}
              {isAddParticipantsOpen && (
                <AddParticipants
                  program={program}
                  closeModal={(shouldRedirect, page) => {
                    if (shouldRedirect) {
                      setCurrentPage(page);
                      setRefreshInvites(!refreshInvites);
                    }
                    setIsAddParticipantsOpen(false);
                  }}
                />
              )}
            </ParticipantsOuterContainer>
          ) : null}
        </>
      )}
    </ProgramParticipantsContainer>
  );
}
export default ProgramParticipants;
